import React, { useState } from "react";
import Layout2 from "@/components/Layout/Layout2";
import { onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { Separator } from "@/components/ui/separator";

const SingleOrderStatus = () => {
  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}
      pageName={{ icon: true, title: "Order ID : KI5847hj" }}
      paths={[
        // { name: "Home", path: "/home" },
        // { name: "Online Ordering", path: "/online-ordering" },
        {
          name: "Website Ordering",
          path: "/onlineordering/website-ordering/order-request",
        },
        {
          name: "Order Status",
          path: "/onlineordering/website-ordering/order-status",
        },
        { name: "Single Order" },
      ]}
    >
      <div className="container grid grid-cols-1 md:grid-cols-2 gap-4 py-5">
        <div>
          <h2 className=" py-2 text-lg font-semibold text-color5">
            Order Summary
          </h2>
          <Card className="col-span-1 border p-5 text-sm flex flex-col gap-3">
            <p>
              <span className="mr-[76px]">Order ID</span>
              <span>: #ORD-20250723-1234</span>
            </p>
            <p>
              <span className="mr-3">Order Time & Date</span>
              <span>: 28/05/2025-10:00AM</span>
            </p>
            <p>
              <span className="mr-[61px]">Order Type</span>
              <span>: Delivery</span>
            </p>
            <p>
              <span className="mr-[53px]">Order Status</span>:
              <span className="text-cyellow"> Request</span>
            </p>
          </Card>
        </div>
        <div>
          <h2 className=" py-2 text-lg font-semibold text-color5">
            Customer Info
          </h2>
          <Card className="col-span-1 border p-5 text-sm flex flex-col gap-3">
            <p>
              <span className="mr-[26px]">Customer Name</span>
              <span>: #ORD-20250723-1234</span>
            </p>
            <p>
              <span className="mr-[33px]">Phone Number</span>
              <span>: 28/05/2025-10:00AM</span>
            </p>
            <p>
              <span className="mr-[94px]">Email</span>
              <span>: Delivery</span>
            </p>
            <p>
              <span className="mr-6">Delivery Address</span>
              <span>: Request</span>
            </p>
          </Card>
        </div>
      </div>
      <div className="container grid grid-cols-1 py-5 pt-0">
        <div>
          <h2 className=" py-2 text-lg font-semibold text-color5">
            Order Items Details
          </h2>
          <Card className="bg-transparent col-span-1 md:col-span-2">
            <Table>
              <TableHeader>
                <TableRow className="border-b-[#505050]">
                  <TableHead>Item Name</TableHead>
                  <TableHead>Quantity</TableHead>
                  <TableHead>Add-ons</TableHead>
                  <TableHead>Modifiers</TableHead>
                  <TableHead>Notes</TableHead>
                  <TableHead>Price</TableHead>
                </TableRow>
              </TableHeader>
              {/* <Separator className="absolute top-8" /> */}
              <TableBody>
                {Array(7)
                  .fill(0)
                  .map((_, i) => (
                    <TableRow key={i}>
                      <TableCell>BBQ Chicken Stack Burger</TableCell>
                      <TableCell>2</TableCell>
                      <TableCell>Mozzarella Magic</TableCell>
                      <TableCell>well cook</TableCell>
                      <TableCell>N/A</TableCell>
                      <TableCell>$50</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Card>
        </div>
      </div>
      <div className="container flex justify-between align-middle py-5 pt-0">
        <div className="w-80">
          <h2 className=" py-2 text-lg font-semibold text-color5">
            Payment Info
          </h2>
          <Card className="col-span-1 border p-5 text-sm">
            <p className="pb-3">
              <span className="mr-5">Payment Status</span>:
              <span className="text-cyellow"> Paid</span>
            </p>
            <p>
              <span className="mr-[7px]">Payment Method</span>
              <span>: Card</span>
            </p>
          </Card>
        </div>
        <div className="w-80">
          <Card className="col-span-1 border p-5 text-sm">
            <p className="flex justify-between pb-3">
              <span className="mr-[26px]">Sub Total</span>
              <span>£ 1000.00</span>
            </p>
            <p className="flex justify-between pb-3">
              <span className="mr-[34px]">Discount</span>
              <span>-£ 50.00</span>
            </p>
            <p className="flex justify-between pb-5">
              <span className="mr-[104px]">Delivery Charge</span>
              <span>£ 5.00</span>
            </p>
            <Separator className="top-8" />
            <p className="flex justify-between text-cyellow pt-3">
              <span className="mr-6">Total</span>
              <span className="font-medium text-base">£ 945.00</span>
            </p>
          </Card>
        </div>
      </div>
      <div className="container grid grid-cols-5 gap-4 py-5 text-color5 text-sm font-semibold">
        <button className="bg-color11 rounded-[5px] py-4">Accept order</button>
        <button className="bg-cviolet rounded-[5px] py-4">Print Bill</button>
        <button className="bg-color12 rounded-[5px] py-4">
          Print Kitchen Copy
        </button>
        <button className="bg-color13 rounded-[5px] py-4">
          Assign To Rider
        </button>
        <button className="bg-color14 rounded-[5px] py-4">Cancel Order</button>
      </div>
    </Layout2>
  );
};

export default SingleOrderStatus;
